<h2 mat-dialog-title>Create app user</h2>

<mat-dialog-content class="dialog-body">
	<p class="text-muted small mb-2">
		<strong>{{ data.row.salesmanname }}</strong>
		<span class="text-monospace">({{ data.row.salesmancode }})</span>
	</p>

	<p *ngIf="!data.usergroups?.length" class="text-danger small mb-2">No user groups were returned. You cannot create a user until groups exist.</p>
	<p *ngIf="!data.locations?.length" class="text-danger small mb-2">No warehouse locations were returned. Check Company Setup / locations.</p>

	<form [formGroup]="form" id="salesman-app-user-form" (ngSubmit)="submit()">
		<mat-form-field appearance="outline" class="full-width">
			<mat-label>User id</mat-label>
			<input matInput formControlName="userid" autocomplete="off" />
			<mat-hint>Prefilled from salesperson extra login when valid; stored lowercase.</mat-hint>
			<mat-error *ngIf="form.get('userid')?.hasError('required')">Required</mat-error>
			<mat-error *ngIf="form.get('userid')?.hasError('pattern')">Letters, numbers, . _ - only</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Password</mat-label>
			<input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="new-password" />
			<button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" matTooltip="{{ hidePassword ? 'Show' : 'Hide' }}">
				<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
			</button>
			<button mat-icon-button matSuffix type="button" (click)="generatePassword()" matTooltip="Generate password">
				<mat-icon>vpn_key</mat-icon>
			</button>
			<mat-error *ngIf="form.get('password')?.hasError('required')">Required</mat-error>
			<mat-error *ngIf="form.get('password')?.hasError('minlength')">At least 4 characters</mat-error>
			<mat-hint *ngIf="form.get('password')?.value">Legacy portal password from extra is prefilled when it looks plain (not a hash).</mat-hint>
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Email</mat-label>
			<input matInput type="email" formControlName="email" />
			<mat-hint>From <code>salesman_extra.smanemail</code> when present.</mat-hint>
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label>User group</mat-label>
			<mat-select formControlName="user_group" [compareWith]="compareGroupId">
				<mat-option *ngFor="let g of data.usergroups" [value]="g.user_group_id">
					{{ g.name }}<ng-container *ngIf="g.user_count != null"> ({{ g.user_count }} users)</ng-container>
				</mat-option>
			</mat-select>
			<mat-hint>Same list as New User.</mat-hint>
			<mat-error *ngIf="form.get('user_group')?.hasError('required')">Required</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Default location</mat-label>
			<mat-select formControlName="defaultlocation" [compareWith]="compareLoccode">
				<mat-option *ngFor="let loc of data.locations" [value]="loc.loccode">
					{{ loc.loccode }} – {{ loc.locationname || loc.orignalname || loc.loccode }}
				</mat-option>
			</mat-select>
			<mat-hint>All company locations (same source as New User).</mat-hint>
			<mat-error *ngIf="form.get('defaultlocation')?.hasError('required')">Required</mat-error>
		</mat-form-field>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="cancel()">Cancel</button>
	<button
		mat-raised-button
		color="accent"
		type="submit"
		form="salesman-app-user-form"
		[disabled]="saving || !canSubmit || form.invalid"
	>
		Create user
	</button>
</mat-dialog-actions>
